import { Location } from '@angular/common';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { IcaRateModel } from 'src/app/models/management/ica-rate.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { CityTableModel } from 'src/app/models/tables/management/city-table.model';
import { WindowService } from 'src/app/services/authentication/window.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { CityService } from 'src/app/services/management/city.service';
import { IcaRateService } from 'src/app/services/management/ica-rate.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';


@Component({
  selector: 'app-register-ica-rate',
  templateUrl: './register-ica-rate.component.html',
  styleUrls: ['./register-ica-rate.component.scss'],
  standalone: false
})
export class RegisterIcaRateComponent implements OnInit {

  @ViewChild('selectCity') citySelectionModalComponent?: CustomModalComponent | null = null;
  ascendantCity: boolean = true;
  branchId: number = 0;
  city: string = '';
  cityData: PagedResponseModel<CityTableModel> = new PagedResponseModel<CityTableModel>();
  columnSortCity: string | null = null;
  componentCitySelection = CustomTableSelectComponent;
  department: string = '';
  disabledForm: boolean = false;
  filtersCity: ColumnResponseModel[] = [];
  formIcaRate: FormGroup = new FormGroup({});
  headersCity: ColumnResponseModel[] = [];
  icaRateContract: IcaRateModel = new IcaRateModel();
  icaRateId: number = 0;
  inputsForSelectCityModal$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    filters: [],
    showCheckbox: true,
    showRecover: true
  });
  isOpened: string | undefined = undefined;
  limitCity: number = 10;
  listConceptInvoicing: any[] = [];
  nameWindow: string = 'Captura Tarifas ICA';
  output$ = new Subject<any>();
  pageCity: number = 1;
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  subscription: Subscription;
  url: string = 'ica-rate';

  constructor(private confirmDialogService: ConfirmDialogService,
    private activatedRoute: ActivatedRoute,
    private cityService: CityService,
    private formBuilder: FormBuilder,
    private headerService: HeaderService,
    private location: Location,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private icaRateService: IcaRateService,
    private windowService: WindowService) {
    this.validateForm(new IcaRateModel());
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.activatedRoute.params.subscribe(params => {
      this.icaRateId = Object.keys(params).length > 0 ? params?.id : null;
    });
    await this.getPermission();
    this.handleInitialState();
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeCity(payload);
          break;
        case 'onFilterChange':
          this.onFilterChangeCity(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  clearForm() {
    this.city = '';
    this.department = '';
    this.icaRateId = 0;
    this.icaRateContract = new IcaRateModel();
    this.validateForm(this.icaRateContract);
  }

  async changeConcept(conceptId: number | null) {
    const cityId = this.formIcaRate.get("cityId")?.value;
    if (!conceptId) {
      this.clearForm();
      return;
    }
    if (!cityId) {
      this.toastHandlerService.showToast('warning', `Seleccione una Ciudad.`);
      setTimeout(() => this.formIcaRate.patchValue({ conceptInvoicingId: 0 }), 100);
      return;
    }
    try {
      const response = await firstValueFrom(this.icaRateService.getIcaRateByCityByConceptInvoicing(cityId, conceptId));
      this.icaRateId = response.icaRateId;
      this.icaRateContract = response;
      this.validateForm(this.icaRateContract);
      this.location.replaceState(`/${this.url}/register/${this.icaRateId}`);
    } catch (error) {
      console.error('Error al obtener la tarifa ICA.', error);
    }
  }

  createNewRegister() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', 'El usuario no tiene permisos para crear tarifas ICA. Comuníquese con el administrador del sistema.');
      return;
    }
    this.clearForm();
    this.location.replaceState(`/${this.url}/register`);
  }

  async delete() {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('error', 'El usuario no tiene permisos para eliminar la tarifa ICA. Comuníquese con el administrador del sistema.');
      return;
    }
    if (!this.icaRateId) {
      this.toastHandlerService.showToast('warning', 'Debe crear una tarifa ICA.');
      return;
    }
    if (await this.confirmDialogService.confirm('¿Realmente desea eliminar la tarifa ICA?')) {
      try {
        await firstValueFrom(this.icaRateService.deleteIcaRate(this.icaRateContract.icaRateId));
        this.createNewRegister();
        this.toastHandlerService.showToast('success', 'La tarifa ICA fue eliminada exitosamente.');
      } catch (error) {
        console.error('Error al eliminar la tarifa.', error);
      }
    }
  }

  async getAllConceptInvoicingForSelect() {
    try {
      this.listConceptInvoicing = await firstValueFrom(this.icaRateService.getAllConceptInvoicingForSelect());
    } catch (error) {
      console.error('Error al obtener los conceptos.', error);
    }
  }

  async getCityDepartment(cityId: number) {
    try {
      const response: any = await firstValueFrom(this.cityService.getCityDepartment(cityId));
      this.city = response.city;
      this.department = response.department;
    } catch (error) {
      console.error('Error al obtener la ciudad y el departamento.', error);
    }
  }

  async getCitiesForSelection() {
    try {
      this.cityData = await firstValueFrom(this.cityService.getCitiesForSelection(this.pageCity, this.limitCity,
        this.columnSortCity, this.ascendantCity, this.filtersCity));
      this.updateInputsForSelectCityModal();
    } catch (error) {
      console.error('Error al obtener las ciudades para el modal.', error);
    }
  }

  async getColumnsForCitiesSelection() {
    try {
      if (this.headersCity.length === 0) {
        this.headersCity = await firstValueFrom(this.cityService.getColumnsForCitySelection());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para el modal de ciudades.', error);
    }
  }

  async getIcaRateById() {
    try {
      const response = await firstValueFrom(this.icaRateService.getIcaRateById(this.icaRateId));
      if (response.cityId) { await this.getCityDepartment(response.cityId); }
      this.icaRateContract = response;
      this.validateForm(this.icaRateContract);
      this.location.replaceState(`/${this.url}/register/${this.icaRateId}`);
    } catch (error) {
      console.error('Error al obtener la tarifa ICA por id.', error);
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast('error', `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`);
      }
    } else {
      localStorage.clear();
    }
    await Promise.all([
      this.getPermissionProfileByUrl(),
      this.getAllConceptInvoicingForSelect()
    ]);
  }

  async getPermissionProfileByUrl() {
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async handleInitialState() {
    if (this.icaRateId !== null && this.icaRateId !== 0) {
      await this.getIcaRateById();
    } else {
      this.createNewRegister();
    }
  }

  async onFilterChangeCity(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filtersCity = this.removeDuplicates(filters);
    this.filtersCity.forEach((filter: any) => this.processFilter(filter));
    this.updateInputsForSelectCityModal();
  }

  async onPageChangeCity(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.pageCity = event.page;
    this.limitCity = event.pageSize;
    this.columnSortCity = event.sortField || null;
    this.ascendantCity = event.sortOrder === 1;
    this.getCitiesForSelection();
  }

  async openCitySelectionModal() {
    try {
      this.filtersCity = [];
      this.updateInputsForSelectCityModal();
      await Promise.all([
        this.getColumnsForCitiesSelection(),
        this.getCitiesForSelection()
      ]);
      this.citySelectionModalComponent?.show();
    } catch (error) {
      console.error('Error al abrir el modal de selección de ciudad.', error);
    }
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filtersCity = this.filtersCity.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filtersCity.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  async changeCity(selectedItem: any) {
    this.icaRateId = 0;
    const [city] = selectedItem;
    this.icaRateContract = new IcaRateModel();
    this.icaRateContract.cityId = city.id;
    this.validateForm(this.icaRateContract);
    this.city = `${city.code} - ${city.name}`;
    this.department = `${city.departmentCode} - ${city.departmentName}`;
  }

  async send() {
    this.validateFormControls();
    if (this.formIcaRate.valid) {
      const modelIcaRate = this.formIcaRate.getRawValue() as IcaRateModel;
      if (this.icaRateId == 0) {
        try {
          const response = await firstValueFrom(this.icaRateService.createIcaRate(modelIcaRate));
          this.icaRateId = response.icaRateId;
          this.icaRateContract = response;
          this.validateForm(this.icaRateContract);
          this.location.replaceState(`/${this.url}/register/${this.icaRateId}`);
          this.toastHandlerService.showToast('success', `La tarifa ICA fue creada exitosamente.`);
        } catch (error) {
          console.error('Error al crear la tarifa ICA.', error);
        }
      } else {
        this.icaRateContract.rate = modelIcaRate.rate;
        this.icaRateContract.minimumBase = modelIcaRate.minimumBase;
        this.icaRateContract.code = modelIcaRate.code;
        this.icaRateContract.saleAccount = modelIcaRate.saleAccount;
        this.icaRateContract.saleDevolutionAccount = modelIcaRate.saleDevolutionAccount;
        this.icaRateContract.payAccountSelfWithholdingICA = modelIcaRate.payAccountSelfWithholdingICA;
        this.icaRateContract.devolutionAccountSelfWithholdingICA = modelIcaRate.devolutionAccountSelfWithholdingICA;
        try {
          const response = await firstValueFrom(this.icaRateService.updateIcaRate(this.icaRateContract));
          this.icaRateContract = response;
          this.validateForm(this.icaRateContract);
          this.toastHandlerService.showToast('success', `La tarifa ICA fue modificada exitosamente.`);
        } catch (error) {
          console.error('Error al actualizar la tarifa ICA.', error);
        }
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      cityId: {
        required: 'Debe seleccionar una Ciudad.',
        min: 'Debe seleccionar una Ciudad válida.'
      },
      conceptInvoicingId: {
        required: 'Debe seleccionar un Concepto de Facturación.',
        min: 'Debe seleccionar un Concepto válido.'
      },
      rate: {
        min: 'La Tasa no puede ser menor que 0.',
        max: 'La Tasa no puede superar 999.99.'
      },
      minimumBase: {
        min: 'La Base Mínima no puede ser menor que 0.',
        max: 'La Base Mínima no puede superar 99.999.999.999.99.'
      },
      code: {
        maxlength: 'El Código no puede tener más de 10 caracteres.'
      },
      saleAccount: {
        maxlength: 'La Cuenta de Venta no puede tener más de 10 caracteres.'
      },
      saleDevolutionAccount: {
        maxlength: 'La Cuenta de Devolución de Venta no puede tener más de 10 caracteres.'
      },
      payAccountSelfWithholdingICA: {
        maxlength: 'La Cuenta de Retención ICA no puede tener más de 10 caracteres.'
      },
      devolutionAccountSelfWithholdingICA: {
        maxlength: 'La Cuenta de Devolución ICA no puede tener más de 10 caracteres.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formIcaRate.get(controlName);
      if (control && control.invalid && control.errors) {
        const messages = controlMessages[controlName];
        Object.keys(control.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  updateInputsForSelectCityModal() {
    this.inputsForSelectCityModal$.next({
      headers: this.headersCity,
      data: this.cityData,
      filters: this.filtersCity,
      showCheckbox: true,
      showRecover: true
    });
  }

  updateFormPermision() {
    if (this.permissionUpdatable) {
      this.disabledForm = false;
      setTimeout(() => this.formIcaRate.enable());
    } else {
      this.disabledForm = true;
      setTimeout(() => this.formIcaRate.disable());
    }
  }

  validateForm(icaRate: IcaRateModel) {
    this.formIcaRate = this.formBuilder.group({
      cityId: [icaRate.cityId, [Validators.required, Validators.min(1)]],
      conceptInvoicingId: [icaRate.conceptInvoicingId, [Validators.required, Validators.min(1)]],
      rate: [icaRate.rate, [Validators.min(0), Validators.max(999.99)]],
      minimumBase: [icaRate.minimumBase, [Validators.min(0), Validators.max(99999999999.99)]],
      code: [icaRate.code, [Validators.maxLength(10)]],
      saleAccount: [icaRate.saleAccount, [Validators.maxLength(10)]],
      saleDevolutionAccount: [icaRate.saleDevolutionAccount, [Validators.maxLength(10)]],
      payAccountSelfWithholdingICA: [icaRate.payAccountSelfWithholdingICA, [Validators.maxLength(10)]],
      devolutionAccountSelfWithholdingICA: [icaRate.devolutionAccountSelfWithholdingICA, [Validators.maxLength(10)]]
    });
    this.updateFormPermision();
  }

  validateFormControls() {
    Object.keys(this.formIcaRate.controls).forEach((key) => {
      const control = this.formIcaRate.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }
}
